import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button } from "shards-react";
import 'react-activity/dist/react-activity.css';

import { Link } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import Firebase from 'firebase';




class OrdersDetailsBaekComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status:'Afgehandeld',
            payment:[],
            items:[],
            setDate:'',
            totalPrice:0,
            sale:0,
            invoiceUrl:'',

      };
    }

    componentDidMount(){


        console.log(this.props.billData.billData);
      
        this.setState({
            status:this.props.billData.billData.status,
            invoicePayed:this.props.billData.billData.invoicePayed 
        })

        if(this.props.billData.billData.invoiceUrl != ''){


            let invoices = Firebase.database().ref('/clients/-907c8a70q98nlcnl9/baek-voiture/'+this.props.billData.billData.id);
            invoices.on('value' , snapshot => {
                this.setState({invoices:[]})
                let state = snapshot.val();
                console.log(state.invoiceUrl)
                Firebase.storage().ref(state.invoiceUrl).getDownloadURL().then((url) => {
                    console.log(url)
                    console.log(state)
                    this.setState({
                        invoiceUrl: url
                    })
                    
    
                  
                  })
           
    
            })
        }
       

    }

    calculatePrice(item){
        let newPrice = item.price * item.amount;
        let setPrice = this.state.totalPrice + newPrice;

        this.setState({
            totalPrice: setPrice
        })

        console.log(this.state.totalPrice)

    }


   
    changeStatus(event){
        console.log(event)
        if(event === 'Geaccepteerd'){
            
            Firebase.database().ref('/clients/-907c8a70q98nlcnl9/baek-voiture/'+this.props.billData.billData.id).update({
               newOrder:false,
               status:event,
    
        
            }).then((data)=>{
    this.setState({
        status:event
    })
   
   
               
    
            }).catch((error)=>{
                //error callback
                console.log('error ' , error)
            })
        }else if(event === 'In behandeling'){
            Firebase.database().ref('/clients/-907c8a70q98nlcnl9/baek-voiture/'+this.props.billData.billData.id).update({
                newOrder:false,
                status:event,
     
         
             }).then((data)=>{
                this.setState({
                    status:event
                })
                toast.success('Status van de inschrijving is in behandeling');
     
                
     
             }).catch((error)=>{
                 //error callback
                 console.log('error ' , error)
             })
        }
        else if(event === 'Geannuleerd'){
            Firebase.database().ref('/clients/-907c8a70q98nlcnl9/baek-voiture/'+this.props.billData.billData.id).update({
                newOrder:false,
                status:event,
     
     
         
             }).then((data)=>{
                this.setState({
                    status:event
                })
                let headers = new Headers();

console.log(this.state.items.length)
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Origin','localhost:3000');
   // headers.append('Origin','https://inno-fruit.beterbijons.nl/')
    headers.append('Access-Control-Allow-Methods', "POST, GET, OPTIONS, DELETE, PUT")

   
    fetch("https://us-central1-cashierr-pixelpros.cloudfunctions.net/cancelBaekVoiture", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({


            email:  this.props.billData.billData.email,
           
            orderId:this.props.billData.billData.orderId,
   
        })
      })
      .then(res => {
        toast.success('Status veranderd naar afgeronde inschrijvingen als geannulleerd');
      }).catch((error)=>{
        //error callback
        console.log('error ' , error)
    })
               
     
                
     
             }).catch((error)=>{
                 //error callback
                 console.log('error ' , error)
             })
        }

        //toast.error('er gaat iets mis probeer het opnieuw')
    }

    sendInvoice(){
        Firebase.database().ref('/clients/-907c8a70q98nlcnl9/baek-voiture/'+this.props.billData.billData.id).update({
            sendInvoice:true,
            saleActive: this.state.sale != ''? true:false,
            sale:this.state.sale
         })
 let headers = new Headers();

console.log(this.state.items.length)
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Origin','localhost:3000');
   // headers.append('Origin','https://inno-fruit.beterbijons.nl/')
    headers.append('Access-Control-Allow-Methods', "POST, GET, OPTIONS, DELETE, PUT")

   
    fetch("https://us-central1-cashierr-pixelpros.cloudfunctions.net/invoiceMarktcommissieBaek", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            id:this.props.billData.billData.id,
            name: this.props.billData.billData.companyName,
            firstname:this.props.billData.billData.firstname,
            lastname:this.props.billData.billData.lastname,
            adres:this.props.billData.billData.adres,
            postal:this.props.billData.billData.postal,
            city:this.props.billData.billData.city,
            country:this.props.billData.billData.country,
            email:  this.props.billData.billData.email,
            phone:  this.props.billData.billData.phone,
            amountPerson: this.props.billData.billData.amountPerson,
            saleActive: this.state.sale != ''? true:false,
            sale:this.state.sale,
            total:this.state.totalPrice,

            orderId:this.props.billData.billData.orderId,
   
        })
      })
      .then(res => {
        
      }).catch((error)=>{
        //error callback
        console.log('error ' , error)
    })
    toast.success('Factuur is verzonden');
    }

    changePaymentStatus(event){

        if(event === 'Ja'){
            Firebase.database().ref('/clients/-907c8a70q98nlcnl9/baek-voiture/'+this.props.billData.billData.id).update({
                invoicePayed: 'Ja',
             })
             toast.success('Wijziging verwerkt');
        }else{
            Firebase.database().ref('/clients/-907c8a70q98nlcnl9/baek-voiture/'+this.props.billData.billData.id).update({
                invoicePayed: 'Nee',
             })
            toast.success('Wijziging verwerkt');
        }
       
    }

    render() {  

        
        return (
            <div>
         <Toaster/>
                <Row >
                <Col sm={12}>
 <Link className="back-link" to={{pathname: `/inschrijvingen-baekvoiture`}} >Terug</Link>
 </Col>
                    <Col sm={6} className="bill-detail-list">
                        <ul>
                            
                        <li>Order id:<span className="bill-detail-list-element">{this.props.billData.billData.orderId}</span></li>
                            <li>Voornaam + achternaam:<span className="bill-detail-list-element">{this.props.billData.billData.firstname} {this.props.billData.billData.lastname}</span></li>
                            <li>E-mail:<span className="bill-detail-list-element">{this.props.billData.billData.email}</span></li>
                            <li>Telefoon:<span className="bill-detail-list-element">{this.props.billData.billData.phone}</span></li>
                            <li>Adres:<span className="bill-detail-list-element"> {this.props.billData.billData.adres}, {this.props.billData.billData.city}</span></li>
                            <li>Kenteken:<span className="bill-detail-list-element"> {this.props.billData.billData.numberCar}</span></li>
                            <li>Merk:<span className="bill-detail-list-element"> {this.props.billData.billData.brandCar}</span></li>
                            <li>Bouwjaar:<span className="bill-detail-list-element"> {this.props.billData.billData.buildCar}</span></li>
                            <li>Aantal personen inclusief bestuurder:<span className="bill-detail-list-element"> {this.props.billData.billData.amountPerson}</span></li>

                            <li>Factuur verzonden:<span className="bill-detail-list-element">{this.props.billData.billData.sendInvoice == undefined && this.props.billData.billData.invoiceUrl == undefined ? 'Nee' :null} {this.props.billData.billData.sendInvoice && this.props.billData.billData.invoiceUrl == undefined ? <i class="far fa-clock"></i> :null}{this.props.billData.billData.sendInvoice && this.props.billData.billData.invoiceUrl != '' ? <i class="far fa-check-circle"></i> :null}</span></li>
                            <li>Factuur:<span className="bill-detail-list-element"> {this.state.invoiceUrl != ''?<a href={this.state.invoiceUrl} target="_blank">Bekijk factuur</a> :null}</span></li>
                            <li>Factuurbedrag: <span className="bill-detail-list-element"> € {parseFloat(((17.50 + (7.50 *    (Number(this.props.billData.billData.amountPerson)-1)))-Number((this.props.billData.billData.sale!=undefined?this.props.billData.billData.sale:0)))).toFixed(2)}</span></li>
                            <li>Korting: <span className="bill-detail-list-element">{this.props.billData.billData.sale != undefined ? "€ "+ Number(this.props.billData.billData.sale!=undefined?this.props.billData.billData.sale:0).toFixed(2):'n.v.t.'}</span></li>
                        </ul>
                    </Col>
                    <Col sm={5} className="bill-detail-list">
                    <span className="input-full-width input-status">
                        <label>Status</label><br/>
                        <select name="orderCountry" value={this.state.status} onChange={(event)=> this.changeStatus(event.target.value)}>
                            <option value="selected" disabled>Selecteer een status</option>
                            <option value="In afwachting">In afwachting</option>
                            <option value="In behandeling">In behandeling</option>
                            <option value="Geaccepteerd">Geaccepteerd</option>
                            <option value="Geannuleerd">Geannuleerd</option>
                        </select>
                    </span>
                    <span className="input-full-width input-status">
                        <label>Euro's korting:</label><br/>
                            <input type="number" value={this.state.sale} onChange={(event)=>this.setState({sale:event.target.value})} />
                        </span>
                        <Button className="align-button-right details-button" onClick={()=>this.sendInvoice()} >Factuur verzenden</Button>
                        {this.props.billData.billData.sendInvoice != ''?this.props.billData.billData.sendInvoice == true?
                          <span className="input-full-width input-status">
                        <label>Factuur betaald</label><br/>
                        <select name="orderCountry" value={this.state.invoicePayed} onChange={(event)=> this.changePaymentStatus(event.target.value)}>
                            <option value="In afwachting">In afwachting</option>
                            <option value="Ja">Ja</option>
                            
                        </select>
                    </span>:null:null}
                    </Col>
                    <Col sm={8}></Col>
                <Col sm={11} className="bills-component">

<table className="bills-table"> 
  <tr>

    <th>Opmerkingen</th>
  </tr>
  <tr className="items-table">

      <td>{this.props.billData.billData.desc == '' ? 'n.v.t.' :this.props.billData.billData.desc}</td>
  </tr>


    
                   
 </table>
 </Col>
 {this.props.billData.billData.imageUrl !='' ?
 <Col sm={6} className="bills-component">
                        <img src={this.props.billData.billData.imageUrl}/>
                    </Col>:null}

 
 <Col sm={12} className="black-space">

 </Col>
                </Row>
                
            
            
            </div>
        );
    }
};

export default OrdersDetailsBaekComponent;
